import React from "react";
import { Plus } from "lucide-react";

const TEAM = [
  {
    name: "Béatrice",
    role: "Directrice de création",
    passion: "Peintre",
    image: "/team/beatrice.jpg",
  },
  {
    name: "Alix",
    role: "Directrice artistique",
    passion: "Céramiste",
    image: "/team/alix.png",
  },
  {
    name: "Florent",
    role: "Fondateur",
    passion: "Jiujitsuka",
    image: "/team/florent.jpg",
  },
  {
    name: "Igor",
    role: "Réalisateur",
    passion: "Kayakiste",
    image: "/team/igor.jpg",
  },
  {
    name: "Loïc",
    role: "Directeur de production",
    passion: "Guitariste",
    image: "/team/loic.jpg",
  },
  {
    name: "Madalina",
    role: "Directrice du planning stratégique",
    passion: "Alpiniste",
    image: "/team/madalina.jpg",
  },
  {
    name: "Marie",
    role: "Directrice de clientèle",
    passion: "Nageuse en mer",
    image: "/team/marie.jpg",
  },
  {
    name: "Rémi",
    role: "Concepteur rédacteur",
    passion: "Photographe",
    image: "/team/remi.webp",
  },
  {
    name: "Tiphaine",
    role: "Motion designer",
    passion: "Barista",
    image: "/team/tiphaine.jpg",
  },
  {
    name: "Tom",
    role: "Motion designer",
    passion: "Photographe",
    image: "/team/tom.png",
  },
];

const PLACEHOLDERS = 0;

export default function Team() {
  return (
    <section
      id="equipe"
      className="relative py-24 md:py-40 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-[#FF5B24]">
              (03) — L'équipe
            </span>
            <h2 className="font-display font-medium text-4xl md:text-7xl mt-6 leading-[1.02] tracking-[-0.03em]">
              Vos interlocuteurs.{" "}
              <span className="font-serif-i text-white/60">Privilégiés.</span>
            </h2>
          </div>
          <p className="max-w-sm text-white/60">
            Stratèges, créatifs, producteurs. Chacun mène une double vie —
            parfois artistique, parfois sportive, toujours passionnée.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {TEAM.map((m, i) => (
            <div
              key={m.name}
              className="group relative overflow-hidden rounded-lg bg-black/40 backdrop-blur-sm border border-white/10 aspect-[3/4]"
            >
              <img
                src={m.image}
                alt={m.name}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />

              {/* Index */}
              <div className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest text-white/60">
                / {String(i + 1).padStart(2, "0")}
              </div>

              {/* Name + role */}
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <div className="font-display text-2xl md:text-3xl font-medium tracking-[-0.02em] text-white">
                  {m.name}
                </div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-white/60 mt-1">
                  {m.role}
                </div>
                <div className="font-serif-i text-[#FF5B24] text-base md:text-lg pt-2">
                  « {m.passion} »
                </div>
              </div>

              {/* Corner accent */}
              <div className="absolute top-3 right-3 w-2 h-2 rounded-full bg-[#FF5B24] opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}

          {/* Placeholders */}
          {Array.from({ length: PLACEHOLDERS }).map((_, i) => (
            <div
              key={`ph-${i}`}
              className="relative overflow-hidden rounded-lg border border-dashed border-white/15 aspect-[3/4] flex items-center justify-center hover:border-[#FF5B24]/50 transition-colors group"
            >
              <div className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest text-white/30">
                / {String(TEAM.length + i + 1).padStart(2, "0")}
              </div>
              <div className="flex flex-col items-center gap-3 text-white/25 group-hover:text-[#FF5B24]/70 transition-colors">
                <span className="w-10 h-10 rounded-full border border-current flex items-center justify-center">
                  <Plus className="w-4 h-4" />
                </span>
                <span className="font-mono text-[10px] uppercase tracking-widest">
                  À venir
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 font-mono text-[10px] uppercase tracking-widest text-white/40 flex items-center gap-3">
          <span className="w-8 h-px bg-white/20" />
          {TEAM.length} portraits — et une équipe qui grandit.
        </div>
      </div>
    </section>
  );
}
